(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sections = Array.prototype.slice.call(document.querySelectorAll('[data-pfs-scroll]'));
  if (!sections.length || reduceMotion) return;

  // Phones get a plain swipeable row (see the max-width: 720px block in
  // plyofold-fold-scroll.css), so the scroll-driven stack only runs above it.
  var phoneQuery = window.matchMedia('(max-width: 720px)');
  var raf = 0;

  // The scroll distance is measured against a viewport height that only
  // changes when the width does, so a browser bar growing or shrinking while
  // scrolling cannot make the stack jump.
  var viewportW = window.innerWidth;
  var viewportH = window.innerHeight;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function smooth(value) {
    return value * value * (3 - (2 * value));
  }

  var states = sections.map(function (section) {
    return {
      section: section,
      cards: Array.prototype.slice.call(section.querySelectorAll('[data-pfs-card]')),
      cardWidth: 0,
      visible: true,
      last: null,
      copyVisible: null
    };
  });

  function measure() {
    states.forEach(function (state) {
      state.cardWidth = state.cards.length ? state.cards[0].offsetWidth : 0;
    });
  }

  // Drop everything the animation wrote, so the phone layout starts clean.
  function reset(state) {
    state.last = null;
    state.copyVisible = null;
    state.cards.forEach(function (card) {
      card.style.removeProperty('transform');
      card.style.removeProperty('z-index');
      card.style.removeProperty('--pfs-dim');
    });
    state.section.style.removeProperty('--pfs-reveal');
    state.section.removeAttribute('data-copy-visible');
    state.section.removeAttribute('data-pfs-ready');
  }

  function prepare(state) {
    state.cards.forEach(function (card, index) {
      card.style.zIndex = String(state.cards.length - index);
    });
    state.section.setAttribute('data-pfs-ready', 'true');
  }

  function updateSection(state) {
    if (!state.visible) return;
    var section = state.section;
    var rect = section.getBoundingClientRect();
    var distance = Math.max(1, rect.height - viewportH);
    var raw = clamp(-rect.top / distance, 0, 1);
    var stack = smooth(clamp((raw - 0.05) / 0.72, 0, 1));
    var reveal = smooth(clamp((raw - 0.54) / 0.24, 0, 1));

    // Nothing moves before the stack starts or after it settles, so skip the
    // style writes while the values are unchanged.
    var key = stack.toFixed(4) + '|' + reveal.toFixed(4);
    if (key === state.last) return;
    state.last = key;

    var startStep = state.cardWidth + 36;
    var endStep = 40;

    // Transform and opacity only: both stay on the compositor. The dimming
    // used to be filter: brightness(), which repaints each photo every frame.
    state.cards.forEach(function (card, index) {
      var x = index * (startStep + ((endStep - startStep) * stack));
      var scale = 1 - (index * 0.02 * stack);
      card.style.transform = 'translate3d(' + x.toFixed(2) + 'px, -50%, 0) scale(' + scale.toFixed(4) + ')';
      card.style.setProperty('--pfs-dim', (index * 0.12 * stack).toFixed(4));
    });

    section.style.setProperty('--pfs-reveal', reveal.toFixed(4));
    var copyVisible = reveal > 0.02;
    if (copyVisible !== state.copyVisible) {
      state.copyVisible = copyVisible;
      section.setAttribute('data-copy-visible', String(copyVisible));
    }
  }

  function updateAll() {
    raf = 0;
    if (phoneQuery.matches) return;
    states.forEach(updateSection);
  }

  function requestUpdate() {
    if (raf || phoneQuery.matches) return;
    raf = window.requestAnimationFrame(updateAll);
  }

  function applyMode() {
    if (phoneQuery.matches) {
      states.forEach(reset);
      return;
    }
    measure();
    states.forEach(function (state) {
      prepare(state);
      state.last = null;
    });
    requestUpdate();
  }

  function onResize() {
    if (window.innerWidth === viewportW) return;
    viewportW = window.innerWidth;
    viewportH = window.innerHeight;
    applyMode();
  }

  // Only do per-frame work while a gallery is on screen.
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        states.forEach(function (state) {
          if (state.section === entry.target) state.visible = entry.isIntersecting;
        });
      });
      requestUpdate();
    }, { rootMargin: '100px 0px' });
    states.forEach(function (state) { io.observe(state.section); });
  }

  document.addEventListener('scroll', requestUpdate, { passive: true, capture: true });
  window.addEventListener('resize', onResize, { passive: true });
  window.addEventListener('load', applyMode, { once: true });
  applyMode();
})();
